export default function PricingSection() {
  const pricingData = [
    {
      service: "おでかけサポート",
      price: "3,300円/30分",
      supplement: [
        "迎車料1,100円／10分",
        "営業所出発時より加算"
      ],
      feature: "福祉タクシー代込み\n車椅子レンタル無料",
      icon: "ri-car-line",
      image: "https://static.readdy.ai/image/ea3bba43a5d95f491f17f4f7543903eb/157b9eded0565099439c46ec8974f3cc.png"
    },
    {
      service: "くらしサポート",
      price: "800円/10分",
      supplement: [
        "出張料550円／回",
        "5km以上〜 1km毎 110円"
      ],
      feature: "家事全般・デジタル活用まで\n幅広く対応",
      icon: "ri-home-heart-line",
      image: "https://static.readdy.ai/image/ea3bba43a5d95f491f17f4f7543903eb/f4c9cd59418381dbbfe39e6937543575.png"
    },
    {
      service: "みまもりサポート",
      price: "550円/10分",
      supplement: [
        "出張料無料",
        "5km以上〜 1km毎 110円"
      ],
      feature: "介護福祉士による専門的な\n見守り・ご家族への報告付き",
      icon: "ri-heart-pulse-line",
      image: "https://static.readdy.ai/image/ea3bba43a5d95f491f17f4f7543903eb/ebd4524428b4eb0620b2c34f0225bf78.png"
    }
  ];

  const details = [
    "時間外割増・障がい者割引あり",
    "支払方法：現金・キャッシュレス・請求書払い",
    "実費：商品代・高速・駐車場など"
  ];

  const includedServices = [
    "車椅子レンタル無料",
    "予約代行無料",
    "チケット購入代行無料",
    "ご家族への報告無料"
  ];

  return (
    <section id="pricing" className="py-28 bg-gradient-to-b from-white to-[#FFFBF0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-bold text-brand-dark mb-6">
            料金について
          </h2>
          <p className="text-2xl md:text-3xl text-gray-700 mb-3 font-bold">
            時間制だから、全部まとめて安心の明朗会計。
          </p>
          <p className="text-lg text-gray-600 leading-relaxed">
            必要なサービスは全部込み。追加料金の心配なし。
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          {/* Pricing Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {pricingData.map((item, index) => (
              <div
                key={index}
                className="group relative bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-200 hover:border-brand-yellow hover:-translate-y-2"
              >
                {/* 上部画像エリア */}
                <div className="relative w-full h-56 overflow-hidden rounded-3xl">
                  <img 
                    src={item.image} 
                    alt={item.service}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                  />
                  {/* グラデーションオーバーレイ */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent rounded-3xl"></div>
                </div>

                {/* コンテンツエリア */}
                <div className="relative p-8">
                  {/* サービス名 */}
                  <h3 className="text-2xl font-bold text-brand-dark text-center mb-5">
                    {item.service}
                  </h3>

                  {/* 特徴バッジ */}
                  <div className="mb-6 flex justify-center">
                    <div className="inline-flex items-center bg-gradient-to-r from-brand-yellow-light via-brand-yellow-light/80 to-brand-yellow-light/60 rounded-full px-5 py-2.5 border border-brand-yellow/20 shadow-sm">
                      <i className="ri-star-fill text-brand-yellow text-sm mr-2"></i>
                      <p className="text-xs font-bold text-brand-dark leading-tight whitespace-pre-line text-center">
                        {item.feature}
                      </p>
                    </div>
                  </div>

                  {/* 料金表示 */}
                  <div className="text-center mb-6">
                    <div className="flex items-baseline justify-center gap-2">
                      <span className="text-5xl font-bold text-brand-yellow tracking-tight">
                        {item.price.split('/')[0]}
                      </span>
                      <span className="text-lg font-semibold text-gray-600">
                        /{item.price.split('/')[1]}
                      </span>
                    </div>
                  </div>

                  {/* 区切り線 */}
                  <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent mb-6"></div>

                  {/* 補足情報 */}
                  <div className="bg-gradient-to-br from-gray-50 to-gray-100/50 rounded-2xl p-5 space-y-2">
                    {item.supplement.map((line, idx) => (
                      <div key={idx} className="flex items-start">
                        <div className="w-1.5 h-1.5 bg-brand-yellow rounded-full mt-2 mr-3 flex-shrink-0"></div>
                        <p className="text-sm text-gray-700 font-medium leading-relaxed flex-1">
                          {line}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* ホバー時の装飾 */}
                <div className="absolute inset-0 bg-gradient-to-br from-brand-yellow/5 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>
              </div>
            ))}
          </div>

          {/* 無料サービス強調エリア */}
          <div className="relative bg-gradient-to-br from-brand-yellow via-brand-yellow-dark to-[#E6A600] rounded-[2rem] p-6 md:p-12 shadow-2xl mb-16 overflow-hidden">
            {/* 背景装飾 */}
            <div className="absolute top-0 right-0 w-80 h-80 bg-white/10 rounded-full -translate-y-40 translate-x-40 blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-80 h-80 bg-white/10 rounded-full translate-y-40 -translate-x-40 blur-3xl"></div>

            <div className="relative z-10">
              <div className="text-center mb-8 md:mb-12">
                <div className="inline-flex items-center bg-white rounded-2xl md:rounded-3xl px-5 py-3 md:px-10 md:py-5 shadow-2xl mb-4 md:mb-8">
                  <i className="ri-gift-line mr-2 md:mr-4 text-2xl md:text-4xl text-brand-yellow"></i>
                  <h3 className="text-xl md:text-3xl lg:text-4xl font-bold text-brand-dark whitespace-nowrap">
                    この金額に全部込み！
                  </h3>
                </div>
                <p className="text-white text-base md:text-2xl lg:text-3xl font-bold drop-shadow-lg px-4">
                  周辺サービスも追加料金なしで、まとめてサポート
                </p>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
                {includedServices.map((service, index) => {
                  const icons = [
                    "ri-wheelchair-line",
                    "ri-calendar-check-line",
                    "ri-ticket-2-line",
                    "ri-24-hours-line"
                  ];
                  return (
                    <div
                      key={index}
                      className="bg-white rounded-2xl md:rounded-3xl p-4 md:p-8 text-center shadow-xl hover:shadow-2xl hover:-translate-y-3 hover:scale-105 transition-all duration-500"
                    >
                      <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-brand-yellow to-brand-yellow-dark rounded-xl md:rounded-2xl flex items-center justify-center mx-auto mb-3 md:mb-5 shadow-md">
                        <i className={`${icons[index]} text-white text-xl md:text-2xl`}></i>
                      </div>
                      <p className="text-brand-dark text-xs md:text-lg font-bold leading-snug whitespace-nowrap">
                        {service}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Additional Details */}
          <div className="bg-white rounded-3xl p-10 shadow-lg border-2 border-gray-100">
            <h3 className="text-2xl font-bold text-brand-dark mb-8 flex items-center justify-center">
              <i className="ri-information-line mr-3 text-3xl text-brand-yellow"></i>
              詳細事項
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {details.map((detail, index) => (
                <div key={index} className="flex items-start bg-brand-yellow-light/30 rounded-2xl p-5 shadow-sm hover:shadow-md transition-shadow duration-300">
                  <div className="w-7 h-7 bg-brand-yellow rounded-full flex items-center justify-center flex-shrink-0 mr-4 mt-0.5">
                    <i className="ri-check-line text-white text-base"></i>
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed font-medium">
                    {detail}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}